import { render } from "./DemoSidebar.vue?vue&type=template&id=98e89fea"
import script from "./DemoSidebar.vue?vue&type=script&lang=js"
export * from "./DemoSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__